import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import App from "./App";
import ProtectedRoute from "./auth/ProtectedRoute";
import SessionExpiryHandler from "./auth/SessionExpiryHandler";
import LoginPage from "./pages/LoginPage";
import StartersPage from "./pages/StartersPage";
import ArmaturesPage from "./pages/ArmaturesPage";
import FieldCasesPage from "./pages/FieldCasesPage";
import AccountPage from "./pages/AccountPage";

const AppRouter = () => (
  <Router>
    <SessionExpiryHandler />
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <App />
          </ProtectedRoute>
        }
      />
      <Route
        path="/starters"
        element={
          <ProtectedRoute>
            <StartersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/armatures"
        element={
          <ProtectedRoute>
            <ArmaturesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/field-cases"
        element={
          <ProtectedRoute>
            <FieldCasesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/account"
        element={
          <ProtectedRoute>
            <AccountPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  </Router>
);

export default AppRouter;
